import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Heart } from "lucide-react";

export default function SponsorshipCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-orange-50 to-pink-50 flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-2xl p-12 text-center">
        <Heart className="w-16 h-16 text-rose-300 mx-auto mb-6" />
        <h1 className="font-heading uppercase text-3xl text-black mb-2">Patrocinio cancelado</h1>
        <p className="text-gray-600 mb-6">No te preocupes, puedes intentarlo de nuevo cuando estés listo.</p>
        <Button onClick={() => nav("/")} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="sponsor-cancel-home">Volver al inicio</Button>
      </div>
    </div>
  );
}
